<template>
    <div class="user_overview" v-if="dataLoaded">
        <img :src="user.imageUrl"
            style="width: 8em; height: 8em; border-radius: 50%; box-shadow: 0 0 10px rgb(0 0 0 / 16%);" />
        <div v-if="user.active">
            <div>{{ user.firstname }} {{ user.lastname }}</div>
            <div>{{ user.email }}</div>
        </div>
        <div v-else style="color: red;">
            {{ $t('DELETED_ACCOUNT') }}
        </div>
        <div>{{ $t('SCORE') }}: {{ user.score }}</div>
        <div style="direction: rtl;">
            <span>
                {{ $t('EVALUATION_POINTS') }}:
            </span>
            <span>
                {{ user.evaluationPoints }}
                <font-awesome-icon :icon="['fas', 'star']" style="color: gold;" />
            </span>
        </div>
        <div>
            <span>{{ $t('OWNER_BOOKS_COUNT') }}:</span>
            <span>
                {{ user.booksCount }}
            </span>
        </div>
        <div>
            <span>{{ $t('REWARDABLE_POINTS') }}:</span>
            <span>
                {{ user.rewardablePoints }}
            </span>
        </div>
    </div>
</template>

<script setup>
import { ref, onBeforeMount, inject } from 'vue'
import userService from '@/service/UserService'

const dialogRef = inject("dialogRef")
const user = ref()
const dataLoaded = ref(false)

onBeforeMount(async () => {
    user.value = await userService.getUserInfo(dialogRef.value.data.userId)
    dataLoaded.value = true
})

</script>

<style>
.user_overview {
    margin-top: 10px;
    text-align: center;
}
</style>